// Cookie utility functions

function cookieDomainCandidates() {
  const host = String(window.location.hostname || "").toLowerCase();
  const candidates = new Set([""]);

  if (host) candidates.add(host);
  if (host === "localhost" || host.endsWith(".localhost")) {
    candidates.add(".localhost");
  }
  const parts = host.split(".").filter(Boolean);
  if (parts.length >= 2 && host !== "localhost" && host !== "127.0.0.1") {
    candidates.add(`.${parts.slice(-2).join(".")}`);
  }

  return Array.from(candidates);
}

function expireCookie(name, { path = "/", domain = "" } = {}) {
  let serialized = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; max-age=0; path=${path}`;
  if (domain) serialized += `; domain=${domain}`;
  document.cookie = serialized;
}

export const clearAuthCookies = () => {
  const domains = cookieDomainCandidates();
  const names = new Set(["original_hostname", "logout_return_to", "auth_token"]);

  document.cookie.split(";").forEach((cookie) => {
    const [rawName] = cookie.split("=");
    const name = String(rawName || "").trim();
    if (!name) return;
    if (name.includes("token") || name.includes("auth")) {
      names.add(name);
    }
  });

  for (const domain of domains) {
    for (const name of names) {
      expireCookie(name, { path: "/", domain });
      expireCookie(name, { path: "/admin/jobs", domain });
    }
  }
};
